/* eslint-disable @atlassian/tangerine/import/no-relative-package-imports, @atlassian/tangerine/import/no-restricted-paths, @atlassian/tangerine/import/entry-points, @atlassian/tangerine/import/no-parent-imports */

import SuccessIcon from '@atlaskit/icon/core/check-circle';
import CommentIcon from '@atlaskit/icon/core/comment';
import DownloadIcon from '@atlaskit/icon/core/download';
import FeedbackIcon from '@atlaskit/icon/core/feedback';
import ErrorIcon from '@atlaskit/icon/core/status-error';
import InfoIcon from '@atlaskit/icon/core/status-information';
import WarningIcon from '@atlaskit/icon/core/status-warning';
import { token } from '@atlaskit/tokens';

export type FlagMapping = Record<string, Flag>;

export type FlagMappingIcon =
	| typeof SuccessIcon
	| typeof ErrorIcon
	| typeof WarningIcon
	| typeof InfoIcon
	| typeof CommentIcon
	| typeof DownloadIcon
	| typeof FeedbackIcon;

export type Flag = {
	component: FlagMappingIcon;
	label: string;
	color: string;
};

const flagMapping = {
	success: {
		component: SuccessIcon,
		label: 'success',
		color: token('color.icon.success'),
	},
	error: {
		component: ErrorIcon,
		label: 'error',
		color: token('color.icon.danger'),
	},
	info: {
		component: InfoIcon,
		label: 'info',
		color: token('color.icon.information'),
	},
	warning: {
		component: WarningIcon,
		label: 'warning',
		color: token('color.icon.warning'),
	},
	smallInfo: {
		component: InfoIcon,
		label: 'info',
		color: token('color.icon.discovery'),
	},
	comment: {
		component: CommentIcon,
		label: 'comment',
		color: token('color.icon'),
	},
	download: {
		component: DownloadIcon,
		label: 'download',
		color: token('color.icon'),
	},
	feedback: {
		component: FeedbackIcon,
		label: 'comment',
		color: token('color.icon'),
	},
};

export type FlagIcons = keyof typeof flagMapping;

export default flagMapping;
